import { render, staticRenderFns } from "./ModalSettingPlugin.vue?vue&type=template&id=21fddd2b"
import script from "./ModalSettingPlugin.vue?vue&type=script&lang=js"
export * from "./ModalSettingPlugin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports